import { useCallback, useState } from 'react';
import { UsersService } from '../../../../../services/usersService';

const useTechniciansNear = () => {
  const [technicians, setTechnicians] = useState([]);
  const [isLoading, setLoading] = useState(false);
  
  const getTechniciansNear = useCallback(async ({ headquarter, specialities, coordinates, limit }) => {
    try {
      setLoading(true);
      const result = await UsersService.getTechniciansNear({ headquarter, specialities, coordinates, limit });
      setTechnicians(result.userGeoTracks || []);
    } finally {
      setLoading(false);
    }
  }, []);

  return { getTechniciansNear, technicians, isLoading };
};

export default useTechniciansNear;
